export const changeControlDe = {
  title: 'Änderungsmanagement',
  subtitle:
    'Modulübergreifende Auswirkungen bewerten, Prüfungen steuern und Revisionen kontrolliert erzeugen.',
  help: 'Hilfe zum Änderungsmanagement öffnen',
  tabs: { requests: 'Änderungsanträge', customerApprovals: 'Kundenfreigaben' },
  actions: {
    new: 'Neuer Änderungsantrag',
    analyze: 'Auswirkungen analysieren',
    submit: 'Einreichen',
    reviewed: 'Prüfung abschließen',
    'changes-requested': 'Korrektur anfordern',
    approve: 'Freigeben',
    reject: 'Ablehnen',
    'start-implementation': 'Umsetzung starten',
    complete: 'Umsetzung abschließen',
    cancel: 'Antrag stornieren',
    archive: 'Archivieren',
  },
  filters: {
    search: 'Nummer, Titel, Quelle oder Artikel suchen',
    allStatuses: 'Alle Status',
    allRisks: 'Alle Risikostufen',
    allSources: 'Alle Quelltypen',
  },
  columns: {
    number: 'Nummer',
    title: 'Titel',
    source: 'Quelle',
    status: 'Status',
    risk: 'Risiko',
    responsible: 'Verantwortlich',
    impact: 'Betroffene Objekte',
    updated: 'Geändert',
    actions: 'Aktionen',
  },
  statuses: {
    DRAFT: 'Entwurf',
    IN_REVIEW: 'In Prüfung',
    CHANGES_REQUESTED: 'Korrektur erforderlich',
    REVIEWED: 'Geprüft',
    APPROVED: 'Freigegeben',
    IMPLEMENTING: 'In Umsetzung',
    IMPLEMENTED: 'Umgesetzt',
    REJECTED: 'Abgelehnt',
    CANCELLED: 'Storniert',
    ARCHIVED: 'Archiviert',
  },
  risks: { LOW: 'Niedrig', MEDIUM: 'Mittel', HIGH: 'Hoch', CRITICAL: 'Kritisch' },
  sourceTypes: {
    PRODUCT: 'Artikel / Rohstoff',
    MATERIAL_PROFILE: 'Materialprofil',
    SUPPLIER_SPECIFICATION: 'Lieferantenspezifikation',
    RECIPE: 'Rezeptur / BOM',
    DECLARATION: 'Deklaration',
    ANALYSIS_PROFILE: 'Analyse / Nährwerte',
    PROCESS_ROUTING: 'Prozessplan',
    PACKAGING: 'Verpackung',
  },
  assigneeRoles: {
    RESPONSIBLE: 'Verantwortlich',
    REVIEWER: 'Prüfung',
    APPROVER: 'Freigabe',
    OBSERVER: 'Beobachtung',
  },
  taskStatuses: {
    OPEN: 'Offen',
    IN_PROGRESS: 'In Bearbeitung',
    COMPLETED: 'Erledigt',
    CANCELLED: 'Abgebrochen',
  },
  decisions: {
    SUBMITTED: 'Eingereicht',
    REVIEWED: 'Geprüft',
    CHANGES_REQUESTED: 'Korrektur angefordert',
    APPROVED: 'Freigegeben',
    REJECTED: 'Abgelehnt',
    IMPLEMENTING: 'Umsetzung gestartet',
    IMPLEMENTED: 'Umgesetzt',
    CANCELLED: 'Storniert',
    ARCHIVED: 'Archiviert',
  },
  nodeTypes: {
    SOURCE: 'Änderungsquelle',
    RECIPE: 'Rezepturen / BOMs',
    PRODUCT: 'Produkte',
    PRODUCTION_ORDER: 'Produktionsaufträge',
    PRODUCTION_PLAN: 'Produktionsplanung',
    DECLARATION: 'Deklarationen',
    SPECIFICATION: 'Produktspezifikationen',
    LABEL_TEMPLATE: 'Etikettenvorlagen',
    CUSTOMER_APPROVAL: 'Kundenfreigaben',
    SALES_ORDER: 'Offene Kundenaufträge',
    PROCESS_ROUTING: 'Prozesspläne',
    ANALYSIS_PROFILE: 'Analyseprofile',
    PACKAGING: 'Verpackungen',
  },
  draftTargetTypes: {
    RECIPE: 'Rezeptur / BOM',
    PROCESS_ROUTING: 'Prozessplan',
    DECLARATION: 'Deklaration',
    ANALYSIS_PROFILE: 'Analyseprofil',
    SPECIFICATION: 'Produktspezifikation',
    LABEL_TEMPLATE: 'Etikettenvorlage',
  },
  draftStatuses: {
    PROCESSING: 'Wird erzeugt',
    CREATED: 'Revision erzeugt',
    FAILED: 'Erzeugung fehlgeschlagen',
  },
  relations: {
    SOURCE_PRODUCT: 'gehört zu',
    OUTPUT_PRODUCT: 'erzeugt',
    SOURCE_RECIPE: 'ändert',
    USED_AS_COMPONENT: 'wird verwendet in',
    USED_AS_SUB_RECIPE: 'ist Unterrezeptur von',
    HAS_PROCESS_ROUTING: 'hat Prozessplan',
    PLANNED_PRODUCTION: 'ist eingeplant in',
    MRP_PROPOSAL: 'hat Vorschlag',
    HAS_DECLARATION: 'hat Deklaration',
    HAS_SPECIFICATION: 'hat Spezifikation',
    LABEL_USED_FOR_PRODUCT: 'verwendet Etikett',
    CUSTOMER_APPROVED_PRODUCT: 'ist freigegeben für',
    OPEN_SALES_ORDER: 'ist bestellt in',
    HAS_ANALYSIS: 'hat Analyse',
    HAS_PACKAGING: 'hat Verpackung',
  },
  form: {
    newTitle: 'Änderungsantrag anlegen',
    newDescription: 'Quelle, Zielzustand, Risiko und unabhängige Verantwortlichkeiten erfassen.',
    editTitle: 'Änderungsantrag bearbeiten',
    editDescription: 'Nur Entwürfe und zurückgegebene Anträge sind bearbeitbar.',
    title: 'Titel',
    reason: 'Grund',
    sourceType: 'Quelltyp',
    source: 'Quellobjekt',
    sourceVersion: 'Quellversion',
    sourceSearch: 'Quelle suchen',
    sourceSearchPlaceholder: 'Nummer, Name, Lieferant oder Domäne',
    selectSource: 'Kontrollierte Quelle auswählen',
    noSources: 'Keine passende Quelle vorhanden.',
    noVersion: 'Stammdaten ohne getrennte Version',
    sourceIdPlaceholder: 'ID des Quellobjekts',
    optionalId: 'Optionale Versions-ID',
    selectProduct: 'Artikel auswählen',
    risk: 'Risikostufe',
    riskAssessment: 'Risikobewertung',
    before: 'Vorher',
    after: 'Nachher',
    requestedEffectiveDate: 'Gewünschtes Wirksamkeitsdatum',
    effectiveDate: 'Wirksamkeitsdatum',
    dueDate: 'Frist',
    responsibleId: 'Verantwortliche Person',
    reviewerId: 'Prüfende Person',
    approverId: 'Freigebende Person',
    selectUser: 'Benutzer auswählen',
    note: 'Begründete Notiz',
  },
  messages: {
    invalidJson: 'Vorher- und Nachher-Werte müssen jeweils ein gültiges JSON-Objekt sein.',
    invalidForm: 'Bitte alle Pflichtfelder mit gültigen Werten ausfüllen.',
    noteRequired: 'Bitte eine begründete Notiz mit mindestens drei Zeichen eingeben.',
    created: 'Änderungsantrag {{number}} wurde angelegt.',
    saved: 'Änderungen gespeichert.',
    analyzed: 'Impact-Analyse gespeichert.',
    notFound: 'Der Änderungsantrag wurde nicht gefunden.',
    workflow: {
      submit: 'Zur Prüfung eingereicht.',
      reviewed: 'Prüfung abgeschlossen.',
      'changes-requested': 'Korrektur angefordert.',
      approve: 'Änderungsantrag freigegeben.',
      reject: 'Änderungsantrag abgelehnt.',
      'start-implementation': 'Umsetzung gestartet.',
      complete: 'Umsetzung abgeschlossen.',
      cancel: 'Änderungsantrag storniert.',
      archive: 'Änderungsantrag archiviert.',
    },
  },
  sections: {
    overview: 'Übersicht',
    request: 'Antrag und Risiko',
    assignees: 'Verantwortlichkeiten',
    diff: 'Vorher / Nachher',
    impact: 'Impact-Graph',
    tasks: 'Aufgaben',
    drafts: 'Kontrollierte Revisionen',
    documents: 'Dokumente',
    audit: 'Prüf- und Audit-Verlauf',
  },
  diff: {
    beforeDescription: 'Mit dem Antrag festgehaltener, unveränderlicher Ausgangsstand.',
    afterDescription: 'Zu prüfender und freizugebender Zielzustand.',
  },
  impact: {
    warnings: 'Warnungen der Impact-Analyse',
    relations: 'Beziehungen',
    noRelations: 'Es wurden keine Beziehungen ermittelt.',
    openNode: '{{label}} öffnen',
    requiredTitle: 'Aktuelle Impact-Analyse erforderlich',
    requiredDescription:
      'Vor dem Einreichen müssen alle betroffenen Objekte analysiert und gespeichert werden.',
    notAnalyzed: 'Es liegt keine aktuelle Impact-Analyse vor.',
    version: 'Impact-Snapshot v{{version}}, erstellt am {{date}}',
  },
  impactWarnings: {
    SUPPLIER_SOURCE_NOT_VERSIONED:
      'Lieferanteninformationen haben keine getrennte Version; die Änderungsakte friert ihre Vorher-/Nachher-Werte ein.',
    PACKAGING_SOURCE_NOT_VERSIONED:
      'Verpackungsstammdaten haben keine getrennte Version; die Änderungsakte friert ihre Vorher-/Nachher-Werte ein.',
    BOM_TRAVERSAL_DEPTH_REACHED: 'Die BOM-Verfolgung hat die maximale Tiefe von 50 erreicht.',
    NO_DEPENDENCIES: 'Für diese Quelle wurden keine abhängigen Objekte gefunden.',
  },
  tasks: {
    new: 'Aufgabe hinzufügen',
    description: 'Konkrete Umsetzungs- oder Prüfaktivität mit Verantwortung und Frist zuordnen.',
    created: 'Aufgabe angelegt.',
    completedInUi: 'Im Änderungsworkflow erledigt.',
    complete: 'Erledigen',
    reopen: 'Wieder öffnen',
    columns: { status: 'Status', task: 'Aufgabe', assignee: 'Zuständig', due: 'Frist' },
    form: { description: 'Beschreibung' },
  },
  drafts: {
    title: 'Veröffentlichte Stände bleiben unverändert',
    description:
      'Für jeden betroffenen freigegebenen Stand wird kontrolliert ein neuer Entwurf oder eine neue Revision erzeugt. Bestehende Veröffentlichungen werden nie überschrieben.',
    pending: 'Noch keine Revision erzeugt',
    create: 'Revision erzeugen',
    created: 'Ein kontrollierter Entwurf beziehungsweise eine Revision wurde erzeugt.',
  },
  workflow: {
    submit: {
      title: 'Änderungsantrag einreichen',
      description: 'Der Impact-Snapshot wird für die unabhängige Prüfung festgehalten.',
    },
    reviewed: {
      title: 'Prüfung abschließen',
      description: 'Bestätigen, dass Auswirkungen, Risiko und Zielzustand geprüft wurden.',
    },
    'changes-requested': {
      title: 'Korrektur anfordern',
      description: 'Präzise beschreiben, was korrigiert werden muss.',
    },
    approve: {
      title: 'Änderungsantrag freigeben',
      description: 'Wirksamkeitsdatum und unabhängige Freigabenotiz erfassen.',
    },
    reject: {
      title: 'Änderungsantrag ablehnen',
      description: 'Festhalten, warum der Antrag nicht umgesetzt werden darf.',
    },
    'start-implementation': {
      title: 'Umsetzung starten',
      description:
        'Umsetzungsaufgaben und kontrollierte Revisionen können nun abgeschlossen werden.',
    },
    complete: {
      title: 'Umsetzung abschließen',
      description: 'Alle Aufgaben und erforderlichen Folgerevisionen müssen abgeschlossen sein.',
    },
    cancel: {
      title: 'Änderungsantrag stornieren',
      description: 'Die Stornierung wird auditiert und ändert keine veröffentlichten Dokumente.',
    },
    archive: {
      title: 'Änderungsantrag archivieren',
      description:
        'Der abgeschlossene Vorgang und seine Nachweise bleiben unveränderlich erhalten.',
    },
  },
  empty: {
    requests: 'Keine Änderungsanträge entsprechen den Filtern.',
    approvals: 'Keine Kundenfreigaben vorhanden.',
    tasks: 'Noch keine Aufgaben angelegt.',
    drafts:
      'Der aktuelle Impact-Snapshot enthält keinen freigegebenen Stand, der eine Folgerevision benötigt.',
    audit: 'Noch keine Workflow-Entscheidung protokolliert.',
  },
  taskCount: '{{count}} offene Aufgabe(n)',
  pagination: 'Seite {{page}} von {{pages}} · {{total}} Änderungsanträge',
  customer: {
    actions: { new: 'Neue Kundenfreigabe', approve: 'Freigeben', revoke: 'Widerrufen' },
    columns: {
      reference: 'Referenz',
      customer: 'Kunde',
      product: 'Artikel',
      scope: 'Freigabeumfang',
      validity: 'Gültigkeit',
    },
    statuses: {
      DRAFT: 'Entwurf',
      APPROVED: 'Freigegeben',
      EXPIRED: 'Abgelaufen',
      REVOKED: 'Widerrufen',
    },
    form: {
      title: 'Kundenfreigabe erfassen',
      description:
        'Die freigegebenen Daten werden als hashgeschützter Snapshot gespeichert und unabhängig freigegeben.',
      selectCustomer: 'Kunde auswählen',
      snapshot: 'Freigegebener Daten-Snapshot (JSON)',
      validFrom: 'Gültig ab',
      validTo: 'Gültig bis',
    },
    dialog: {
      approve: 'Kundenfreigabe freigeben',
      revoke: 'Kundenfreigabe widerrufen',
      description: 'Entscheidung und Begründung werden im Audit-Trail gespeichert.',
    },
    messages: {
      created: 'Kundenfreigabe angelegt.',
      approved: 'Kundenfreigabe freigegeben.',
      revoked: 'Kundenfreigabe widerrufen.',
    },
  },
} as const;
